import script from "./AnakinHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnakinHeader.vue?vue&type=script&setup=true&lang=ts"

import "./AnakinHeader.vue?vue&type=style&index=0&id=e1045894&lang=scss"

const __exports__ = script;

export default __exports__